import React from 'react';
import Typography from '@/components/shared/typography/typography.component';
import CarChip from '../../CarChip/CarChip';

interface CarInfoProps {
    data: React.ReactNode[];
}

const CarDetailsSection = ({ data }: CarInfoProps) => {
    if (!Array.isArray(data) || data.length === 0) return null;
    return (
        <div className="flex items-center flex-wrap gap-y-1.5 gap-1.5 my-2">
            {data.map((item, index) => (
                <CarChip removeBorder={typeof item !== 'string'} key={index}>
                    {typeof item !== 'string' ? (
                        item
                    ) : (
                        <Typography variant="caption" className="text-gray-700">
                            {item}
                        </Typography>
                    )}
                </CarChip>
            ))}
        </div>
    );
};

export default CarDetailsSection;
